import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';
import { WrapImsPacket } from '../../../../../store/utility';

/**
 * Asynchronously retrieves department IDs matching @param queryParam of user search.
 *
 * @function
 * @param {string} queryParam user search input.
 * @returns {string[]} array of vendors matching input query once promise resolved.
 */
export const getDepartmentIds = queryParam => {
	return axiosInstance
		.post(
			'api/Components/SearchBox',
			WrapImsPacket({ Key: 'DEPARTMENT_IDS', Value: queryParam })
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};

/**
 * Asynchronously search for Department Unit Name exactly matching @param queryParam of user search
 * 
 * @function
 * @param {string} queryParam string to search against
 * @returns {string} result
 */
export const getDepartmentUnit = queryParam => {
	return axiosInstance
		.post(
			'api/Components/SearchBox',
			WrapImsPacket({ Key: 'DEPARTMENT_UNIT', Value: queryParam })
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};